import { render, staticRenderFns } from "./RadioConfig.vue?vue&type=template&id=5a5227f3&scoped=true"
import script from "./RadioConfig.vue?vue&type=script&lang=js"
export * from "./RadioConfig.vue?vue&type=script&lang=js"
import style0 from "./RadioConfig.vue?vue&type=style&index=0&id=5a5227f3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5227f3",
  null
  
)

export default component.exports